import gravyAxios from "@/plugins/axios";

const usersStore = {
    state: () => ({
       users: [],
       userStoreUser: null
    }),
    actions: {
        getUsers: async ({ commit }) => {
            let users = await gravyAxios.get('/users')
           commit('SET_USERS', users.data)

        },
        getUser: async ({ commit}, user) => {
            let userFetched = await gravyAxios.get(`/user/${user.id}`)
            commit('SET_USER', userFetched.data)
        },
        updateUser: async ({commit}, user) => {
            let updatedUser = await gravyAxios.patch('/user', user)
            commit('UPDATE_USER', updatedUser.data)
        },
        createUser: async ({ dispatch }, user ) => {
            const newUser = await gravyAxios.post('/user', user)
            await dispatch('getUsers')
        },
        deleteUser: async ({commit}, user) => {
            await gravyAxios.delete('/user/'+user.id)
            commit('DELETE_USER', user.id)
        }
    },
    mutations: {
        SET_USERS: (state, users) => {
            state.users = users
        },
        SET_USER: (state, user)  => {
            state.userStoreUser = user
       },
        UPDATE_USER: (state, updatedUser) => {
            const index = state.users.findIndex(user => user.id === updatedUser.id);
            if (index !== -1) {
                state.users.splice(index, 1, updatedUser)
            }
        },
        DELETE_USER: (state, userId) => {
          const index = state.users.findIndex(user => user.id === userId)
          state.users.splice(index, 1)
        },
        CLEAR_ACTIVE_USER: state => { state.userStoreUser = null },
    },
    getters: {
        getUsers: state => {
            return state.users;
        },
        getUserStoreUser: state => {
            return state.userStoreUser;
        }
    }
}

export default usersStore
